<template>
  <v-container fluid fill-height grid-list-xs pa-0>
    <v-layout row wrap align-stretch>
      <v-form v-model="valid">
        <v-layout row wrap justify-center>
          <v-flex xs12 sm10 md3 lg3>
            <v-flex xs12>
              <b>Comprador</b>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Clientes', value: true },
                  { text: 'Empresas', value: false }
                ]"
                item-text="text"
                label="Tipo de comprador"
                item-value="value"
                v-model="opcoes.tipo_comprador"
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="opcoes.tipo_comprador === null || opcoes.tipo_comprador === true">
              <v-text-field
                placeholder="Identificação do cliente"
                label="Identificação do cliente"
                class="pr-3"
                v-model="opcoes.id_pessoa"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="opcoes.tipo_comprador === null || opcoes.tipo_comprador === true">
              <v-text-field
                placeholder="CPF do Cliente"
                label="CPF do Cliente"
                mask="###.###.###-##"
                class="pr-3"
                v-model="opcoes.masked_cpf"
                return-masked-value
                :rules="[rules.cpf]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="opcoes.tipo_comprador === null || opcoes.tipo_comprador === false">
              <v-text-field
                placeholder="CNPJ da Empresa"
                label="CNPJ da Empresa"
                mask="##.###.###/####-##"
                class="pr-3"
                v-model="opcoes.masked_cnpj"
                return-masked-value
                :rules="[rules.cnpj]"
              ></v-text-field>
            </v-flex>
          </v-flex>
          <v-divider :vertical="$vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"></v-divider>
          <v-flex xs12 sm5 md3 lg3>
            <v-flex xs12>
              <b>Dados da Compra:</b>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="filtros"
                item-text="title"
                label="Filtros"
                item-value="value"
                v-model="filtro"
              >
              </v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Lido', value: false },
                  { text: 'Aguandando Leitura', value: true }
                ]"
                label="Status"
                v-model="opcoes.disponivel"
              >
              </v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="[
                  { text: 'Pré pago', value: 'prepago' },
                  { text: 'Pós pago', value: 'pospago' }
                ]"
                label="Método de Pagamento"
                class="pr-3"
                v-model="opcoes.metodo_pagamento"
              ></v-select>
            </v-flex>
            <v-flex xs12 shrink>
              <v-select
                :items="frentistas"
                label="Frentista"
                item-value="id_frentista"
                v-model="opcoes.id_frentista"
                clearable
              >
                <template v-slot:item="data">
                  <v-avatar
                    color="grey"
                    size="30">
                    <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                    <v-icon dark v-else>face</v-icon>
                  </v-avatar>
                  <v-spacer></v-spacer>
                  <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                  <v-spacer></v-spacer>
                </template>
                <template v-slot:selection="data">
                  <v-avatar
                    color="grey"
                    size="30">
                    <img v-if="data.item.url_imagem_perfil || (data.item.pessoa && data.item.pessoa.url_imagem_perfil)" :src="data.item.url_imagem_perfil || data.item.pessoa.url_imagem_perfil" alt="trevor">
                    <v-icon dark v-else>face</v-icon>
                  </v-avatar>
                  <v-spacer></v-spacer>
                  <span v-text="`${data.item.nome ? (data.item.nome + ' ' + data.item.sobrenome) : (data.item.pessoa.nome + ' ' + data.item.pessoa.sobrenome)}`"></span>
                  <v-spacer></v-spacer>
                </template>
              </v-select>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm5 md3 lg4>
            <v-flex
              style="margin-bottom: 1.5em;"
              v-if="!$vuetify.breakpoint.xs"
            ></v-flex>
            <v-flex xs12 shrink>
              <v-text-field
                placeholder="NSU"
                v-model="opcoes.nsu"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 shrink>
              <v-text-field
                placeholder="Código"
                v-model="opcoes.codigo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 shrink>
              <v-select
                color="info"
                outlined
                label="app"
                :items="apps"
                v-model="app_selected"
                item-text="text"
                item-value="value"
                dense
                class="pa-2"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                label="Item Vendido"
                :items="itens"
                item-text="nome"
                clearable
                v-model="opcoes.item"
                return-object
              >
                <template v-slot:item="data">
                  <template v-if="data.item.combustivel">
                    <svg-filler :path="require(`@/assets/combs/${data.item.combustivel.icone}.svg`)" width="35px" height="35px" :fill="data.item.combustivel.color"/>
                    {{data.item.combustivel.nome}}
                  </template>
                  <template v-else>
                    <v-icon
                      :color="data.item.categoria.cor"
                      class="ma-2"
                    >
                      {{ data.item.categoria.icone }}
                    </v-icon>
                    <span>{{ data.item.nome }}</span>
                  </template>
                </template>
                <template v-slot:selection="data">
                  <template v-if="data.item.combustivel">
                    <svg-filler :path="require(`@/assets/combs/${data.item.combustivel.icone}.svg`)" width="35px" height="35px" :fill="data.item.combustivel.color"/>
                    {{data.item.combustivel.nome}}
                  </template>
                  <template v-else>
                    <v-icon
                      :color="data.item.categoria.cor"
                      class="ma-2"
                    >
                      {{ data.item.categoria.icone }}
                    </v-icon>
                    <span>{{ data.item.nome }}</span>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-layout justify-space-between>
                <v-flex xs5>
                  <v-select
                    :items="options"
                    item-text="title"
                    item-value="value"
                    v-model="selectOpcoes"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs5>
                  <v-menu
                    ref="menuDataInicial"
                    v-model="menuDataInicial"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-combobox
                        v-if="opcoes.custom"
                        v-model="opcoes.intervalo_relatorio"
                        label="Dias"
                        multiple
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        prepend-icon="event"
                        required
                        v-on="on"
                        clearable
                      ></v-combobox>
                      <v-combobox
                        v-else-if="opcoes.dia"
                        v-model="opcoes.data_relatorio"
                        label="Dia"
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        @blur="date = parseDate(opcoes.data_relatorio)"
                        prepend-icon="event"
                        required
                        v-on="on"
                        clearable
                      ></v-combobox>
                      <v-combobox
                        v-else
                        v-model="opcoes.mes_relatorio"
                        label="Mes"
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        @blur="month = parseDate(opcoes.mes_relatorio)"
                        prepend-icon="event"
                        required
                        v-on="on"
                        clearable
                      ></v-combobox>
                    </template>
                    <v-date-picker v-show="opcoes.custom" multiple v-model="dates" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                    <v-date-picker v-show="opcoes.dia" v-model="date" type="date" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                    <v-date-picker v-show="opcoes.mes" v-model="month" type="month" no-title @input="dataSelecionada" locale="pt-br"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm2 md1 lg1>
            <v-layout justify-center>
              <v-flex shrink xs6>
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                    :icon="!$vuetify.breakpoint.xs"
                    :block="$vuetify.breakpoint.xs"
                    v-on="on"
                    >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                  <v-list>
                    <v-list-tile
                      @click="editando = !editando"
                      >
                      <v-list-tile-action>
                        <v-icon v-if="!editando">edit</v-icon>
                        <v-icon v-else>done</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>Editar relatório</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                    @click="print()"
                    >
                    <v-list-tile-action>
                      <v-icon>print</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title>Imprimir relatório</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
            <v-flex shrink xs6>
             <v-btn
              :icon="!$vuetify.breakpoint.xs"
              :block="$vuetify.breakpoint.xs"
              color="info"
              @click="carregarRelatorio(true)"
            >
              <v-icon>search</v-icon>
            </v-btn>
           </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-form>
      <v-flex xs12 class="print">
        <div class="pb-3 pt-5 hide-display">
          <v-layout row>
            <h1> Relatório de compras</h1>
          </v-layout>
          <v-layout row>
            <span class="display-1">Total: {{ total_relatorio_compras | currency({ fractionCount: 2 }) }}</span>
            <v-spacer></v-spacer>
            <span class="display-1">Total com desconto: {{ valor_compras | currency({ fractionCount: 2 }) }}</span>
          </v-layout>
          <hr/>
        </div>
        <v-data-table
          hide-actions
          :hide-headers="!compras || !compras.length"
          :loading="loading"
          :items="compras"
          :pagination.sync="pagination"
          :total-items="totalItens"
          class="elevation-1"
          v-if="!loading"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center px-0" style="width: 60px"  v-if="headersVisible.item">
                <template v-if="props.item.combustivel">
                  <v-tooltip class="hidden-print-only" :color="props.item.combustivel.color" top>
                      <template v-slot:activator="{ on }">
                          <span class="hidden-print-only" v-on="on">
                              <svg-filler :path="require(`@/assets/combs/${props.item.combustivel.icone}.svg`)" width="40px" height="40px" :fill="props.item.combustivel.color"/>
                          </span>
                      </template>
                      <span>{{props.item.combustivel.nome}}</span>
                  </v-tooltip>
                  <span class="hidden-screen-only">{{props.item.combustivel.nome}}</span>
                </template>
                <template v-else-if="props.item.pedido">
                  <v-tooltip class="hidden-print-only" top>
                      <template v-slot:activator="{ on }">
                          <span class="hidden-print-only" v-on="on">
                              <v-icon color="success">attach_money</v-icon>
                          </span>
                      </template>
                      <span>Compra de Item</span>
                  </v-tooltip>
                  <span class="hidden-screen-only">Compra de Item</span>
                </template>
              </td>
              <td class="text-xs-left px-3"  style="width: 110px" v-if="headersVisible.data_compra">{{ props.item.data_compra.split('-').reverse().join('/') }}</td>
              <td class="text-xs-left px-3"  style="width: 110px" v-if="headersVisible.horario_compra">{{ props.item.horario_compra }}</td>
              <td class="text-xs-left px-3"  style="width: 110px" v-if="headersVisible.codigo">
                <b>{{ props.item.codigo }}</b>
              </td>
              <td class="text-xs-left" v-if="headersVisible.id_pessoa">
                <template v-if="props.item.empresa">
                  {{`${props.item.empresa.nome_fantasia}` | truncate(30) }}
                  <div><strong>{{props.item.empresa.cnpj}}</strong></div>
                </template>
                <template v-else-if="props.item.cliente">
                  {{`${props.item.cliente.pessoa.nome} ${props.item.cliente.pessoa.sobrenome}` | truncate(30) }}
                  <div><strong>{{props.item.cliente.pessoa.id_pessoa}}</strong></div>
                </template>
                <template v-else>
                  Não encontrado
                </template>
              </td>
              <td class="text-xs-left" v-if="headersVisible.frentista">
                {{ props.item.frentista ? props.item.frentista.nome : '' }}
              </td>
              <td class="text-xs-left" style="width: 200px"  v-if="headersVisible.tid">
                {{props.item.token}}
                <div>NSU: <strong>{{props.item.nsu}}</strong></div>
                <div v-if="props.item.brand && props.item.card">Cartão: <strong>{{props.item.brand}} - Final: {{props.item.card.substr(props.item.card.length - 4)}}</strong></div>
              </td>
              <td class="text-xs-center" v-if="headersVisible.desconto">
                {{props.item.desconto || 0}}%
              </td>
              <td class="text-xs-left" v-if="headersVisible.desconto">
                <template v-if="props.item.valor_total">
                  {{ props.item.valor_total | currency({ fractionCount: 2 }) }}
                </template>
                <template v-else-if="props.item.valor">
                  {{ props.item.valor | currency({ fractionCount: 2 }) }}
                </template>
              </td>
              <td class="text-xs-left"  style="width: 120px" v-if="headersVisible.valor">
                  {{ props.item.valor | currency({ fractionCount: 2 }) }}
              </td>
              <td class="text-xs-center px-0" style="width: 40px" v-if="headersVisible.pagamento">
                <v-tooltip v-if="props.item.em_especie" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">attach_money</v-icon>
                  </template>
                  <span>Em dinheiro</span>
                </v-tooltip>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="teal">payment</v-icon>
                  </template>
                  <span>No cartão</span>
                </v-tooltip>
              </td>
              <td class="text-xs-center px-0" style="width: 40px" v-if="headersVisible.confirmada">
                <v-tooltip v-if="props.item.confirmado" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="teal">done_all</v-icon>
                    </template>
                    <span>Pagamento efetuado</span>
                </v-tooltip>
                <v-tooltip v-else top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="red">close</v-icon>
                    </template>
                    <span>Pagamento não efetuado</span>
                </v-tooltip>
              </td>
              <td class="text-xs-center px-0" style="width: 40px" v-if="headersVisible.disponivel">
                <v-tooltip v-if="!props.item.disponivel" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="teal">check_circle</v-icon>
                    </template>
                    <span>Leitura realizada</span>
                </v-tooltip>
                <v-tooltip v-else top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="red">cancel</v-icon>
                    </template>
                    <span>Leitura não realizada</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:headers>
            <tr>
              <th class="text-xs-left px-4" v-if="headersVisible.item">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.item = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-left  px-3" v-if="headersVisible.data_compra">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.data_compra = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Data
              </th>
              <th class="text-xs-left  px-3" v-if="headersVisible.horario_compra">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.horario_compra = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Horario
              </th>
              <th class="text-xs-left  px-3" v-if="headersVisible.codigo">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.codigo = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Código
              </th>
              <th class="text-xs-left" v-if="headersVisible.id_pessoa">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.id_pessoa = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Comprador
              </th>
              <th class="text-xs-left" v-if="headersVisible.frentista">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.frentista = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Frentista
              </th>
              <th class="text-xs-left" v-if="headersVisible.tid">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.tid = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Transação
              </th>
              <th class="text-xs-center" v-if="headersVisible.desconto">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.desconto = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Desconto
              </th>
              <th class="text-xs-left" v-if="headersVisible.valor_total">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor_total = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor Total (R$)
              </th>
              <th class="text-xs-right pl-2 pr-4" v-if="headersVisible.valor">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.valor = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                Valor Pago (R$)
                <v-btn
                  icon
                  small
                  color="success"
                  class="ml-4"
                  @click="exportarExcel"
                  title="Exportar para Excel"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-center px-4" v-if="headersVisible.pagamento">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.pagamento = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-center px-4" v-if="headersVisible.confirmada">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.confirmada = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
              <th class="text-xs-center px-4" v-if="headersVisible.disponivel">
                <v-btn flat icon color="grey" v-if="editando" @click="headersVisible.disponivel = false">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
        </v-data-table>
        <v-layout justify-center v-else>
          <v-progress-circular
            indeterminate
            :size="100"
            color="primairy"
          ></v-progress-circular>
        </v-layout>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="compras.length">
          <v-toolbar-title>
            Valor Recebido: {{ valor_compras | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Total: {{ total_relatorio_compras | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
  </v-container>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      itens: [],
      valor_compras: 0,
      valid: false,
      combustivel: '',
      filtro: 'confirmadas',
      editando: false,
      menuDataInicial: false,
      date: moment().format(`YYYY-MM-DD`),
      month: new Date().toISOString().substr(0, 10),
      dates: [],
      headersVisible: {
        desconto: true,
        item: true,
        horario_compra: true,
        data_compra: true,
        pagamento: true,
        confirmada: true,
        tid: true,
        id_pessoa: true,
        valor: true,
        valor_total: true,
        avatar: true,
        disponivel: true,
        codigo: true,
        frentista: true
      },
      rules: {
        cpf: value => {
          const pattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
          return !value || pattern.test(value) || 'CPF inválido.'
        },
        cnpj: value => {
          const pattern = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/
          return !value || pattern.test(value) || 'CNPJ inválido.'
        }
      },
      today: null,
      selectOpcoes: 'dia',
      filtros: [
        {
          title: 'Confirmadas',
          value: 'confirmadas'
        },
        {
          title: 'Todas',
          value: 'todas'
        }
      ],
      options: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'custom'
        }
      ],
      opcoes: {
        dia: true,
        custom: false,
        mes: false,
        data_relatorio: moment().format(`DD/MM/YYYY`),
        mes_relatorio: null,
        intervalo_relatorio: [],
        item: null,
        confirmadas: true,
        id_pessoa: null,
        masked_cpf: undefined,
        masked_cnpj: undefined,
        nsu: null,
        codigo: null,
        metodo_pagamento: 'prepago',
        tipo_comprador: null,
        id_frentista: undefined,
        disponivel: null
      },
      app_selected: null,
      compras: [],
      totalItens: 0,
      pagination: {
        page: 1,
        rowsPerPage: 20
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    total_relatorio_compras () {
      return this.$store.getters.total_relatorio_compras
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItens == null
      ) return 0

      const pages = Math.ceil(this.totalItens / this.pagination.rowsPerPage)
      return pages
    },
    frentistas () {
      return this.$store.getters.frentistas
    },
    tempOpcoes () {
      let tempOpcoes = {
        run: true,
        metodo_pagamento__iexact: this.opcoes.metodo_pagamento
      }
      if (this.app_selected === 1) {
        tempOpcoes['is_white_label'] = false
        tempOpcoes['rede_sindicato__isnull'] = true
      }
      if (this.app_selected === 2) {
        tempOpcoes['is_white_label'] = true
        tempOpcoes['rede_sindicato__isnull'] = true
      }
      if (this.app_selected === 3) {
        tempOpcoes['rede_sindicato'] = this.posto.rede_sindicato
        tempOpcoes['is_white_label'] = true
      }
      if (this.filtro !== 'todas') {
        tempOpcoes['confirmado'] = true
        tempOpcoes['recompra'] = false
      }

      if (this.opcoes.tipo_comprador !== null && this.opcoes.tipo_comprador !== undefined) {
        tempOpcoes.is_empresa = this.opcoes.tipo_comprador
      }
      if (this.opcoes.disponivel !== null && this.opcoes.disponivel !== undefined) {
        tempOpcoes['disponivel'] = this.opcoes.disponivel
      }
      this.opcoes.id_frentista && (tempOpcoes['frentista'] = this.opcoes.id_frentista)
      this.opcoes.codigo && this.opcoes.codigo !== '' && (tempOpcoes['codigo__iexact'] = this.opcoes.codigo)
      this.opcoes.id_pessoa && this.opcoes.id_pessoa !== '' && (tempOpcoes['cliente__pessoa'] = this.opcoes.id_pessoa)
      this.valid && this.opcoes.masked_cpf && this.opcoes.masked_cpf !== '' && (tempOpcoes['cliente__pessoa__cpf'] = this.opcoes.masked_cpf.replace(/[^\d]+/g, ''))
      this.valid && this.opcoes.masked_cnpj && this.opcoes.masked_cnpj !== '' && (tempOpcoes['empresa__cnpj'] = this.opcoes.masked_cnpj.replace(/[^\d]+/g, ''))
      this.opcoes.nsu && this.opcoes.nsu !== '' && (tempOpcoes['nsu'] = this.opcoes.nsu)
      if (this.opcoes.item) {
        if (this.opcoes.item.combustivel) tempOpcoes['combustivel'] = this.opcoes.item.combustivel.id_combustivel
        else tempOpcoes['item'] = this.opcoes.item.id
      }

      // Validando as datas
      if (this.opcoes.custom && this.opcoes.intervalo_relatorio && this.opcoes.intervalo_relatorio.length === 2) {
        tempOpcoes['data_compra__gte'] = this.opcoes.intervalo_relatorio[0]
        tempOpcoes['data_compra__lte'] = this.opcoes.intervalo_relatorio[1]
      } else if (this.opcoes.dia && this.date) {
        tempOpcoes['data_compra'] = this.date.split('-').reverse().join('/')
      } else if (this.opcoes.mes && this.month && this.month.length) {
        const initialDate = new Date(`${this.month.split('-')[1]}-01-${this.month.split('-')[0]}`.split('-').join('/'))
        const finalDate = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0)

        tempOpcoes['data_compra__gte'] = initialDate.toISOString().substr(0, 10).split('-').reverse().join('/')
        tempOpcoes['data_compra__lte'] = finalDate.toISOString().substr(0, 10).split('-').reverse().join('/')
      } else {
        tempOpcoes['run'] = false
      }
      return tempOpcoes
    },
    apps () {
      const posto = this.posto
      if (!posto) return []

      const apps = []
      const isSimultaneo = !!posto.is_simultaneo
      const isWhiteLabel = !!posto.is_white_label
      const temSindicato = !!posto.rede_sindicato

      if (isSimultaneo || (!isWhiteLabel && !temSindicato)) {
        apps.push({ text: 'Apetrus', value: 1 })
      }
      if (isWhiteLabel) {
        apps.push({ text: 'Whitelabel', value: 2 })
      }
      if (temSindicato) {
        apps.push({ text: 'Sindicato', value: 3 })
      }
      return apps
    }
  },
  watch: {
    'pagination.page': {
      handler (val, valOld) {
        if (this.posto && val !== valOld) this.carregarRelatorio(false)
      },
      deep: true
    },
    apps (val) {
      if (val && val.length) {
        this.app_selected = val[0].value
      }
    },
    filtro (val) {
      if (val === 'confirmadas') {
        this.opcoes.confirmadas = true
      } else {
        this.opcoes.confirmadas = false
      }
    },
    date (val) {
      if (val) {
        this.opcoes.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    selectOpcoes (val) {
      this.limparOpcoes()
      if (val === 'dia') {
        this.opcoes.dia = true
        this.opcoes.data_relatorio = this.formatDate(this.date)
      } else if (val === 'custom') {
        this.opcoes.custom = true
        this.opcoes.data_relatorio = this.formatDate(this.date)
      } else if (val === 'mes') {
        this.opcoes.mes = true
        this.opcoes.mes_relatorio = this.formatDate(this.month)
      }
    },
    posto (val, oldval) {
      if (!oldval && val) {
        this.$store.dispatch('listarFrentistas')
        this.pegarTodosItens()
      }
    },
    'opcoes.tipo_comprador' (val) {
      if (val) {
        this.opcoes.masked_cnpj = undefined
      } else if (val === false) {
        this.opcoes.masked_cpf = undefined
      }
    }
  },
  mounted () {
    this.today = new Date().setHours(0, 0, 0, 0)
    if (this.posto) {
      this.$store.dispatch('listarFrentistas')
      this.pegarTodosItens()
    }
  },
  methods: {
    print () {
      window.print()
    },
    exportarExcel () {
      const params = {
        ...this.tempOpcoes,
        page: 'notPagination',
        export: 'excel',
        posto: this.posto.cnpj
      }
      this.$store.dispatch('exportarCompras', params)
    },
    formatDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.opcoes.dia || this.opcoes.custom) {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    limparOpcoes () {
      this.opcoes.dia = false
      this.opcoes.custom = false
      this.opcoes.mes = false
    },
    carregarRelatorio (zerarPaginacao) {
      this.headersVisible.tid = this.opcoes.metodo_pagamento !== 'pospago'
      // this.headersVisible.frentista = !!this.opcoes.id_frentista
      if (zerarPaginacao) this.pagination.page = 1
      this.$store.dispatch('relatorioCompras', { filtro: this.tempOpcoes, pagination: this.pagination }).then(json => {
        this.compras = json.results.compras
        this.totalItens = json.count
        this.valor_compras = json.results.valor
      })
    },
    dataSelecionada () {
      if (this.opcoes.custom) {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.opcoes.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    },
    pegarTodosItens () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens = json
      })
    }
  }
}
</script>
